<section class="account-settings-section" [attr.aria-label]="'account.settings.personalInfo.title' | t">
  <h2 class="account-settings-section-title">
    <sn-icon fontSet="fal" fontIcon="fa-user"></sn-icon>
    {{ 'account.settings.personalInfo.title' | t }}
  </h2>
  <div class="account-section-layout">
    <div class="info-column">
      <p *ngIf="!isPersonalInfoReadOnly" class="lead">{{ 'account.settings.personalInfo.description' | t }}</p>
      <div *ngIf="isPersonalInfoReadOnly" class="external-user-notice">
        <p>
          {{ 'account.settings.personalInfo.externallyManagedNotice' | t }}
          <a *ngIf="externalProfileUrl" [href]="externalProfileUrl" target="_blank" rel="noopener noreferrer">
            {{ 'account.settings.personalInfo.evidenceProfileLink' | t }}
          </a>
          <span *ngIf="!externalProfileUrl">{{ 'account.settings.personalInfo.evidenceProfileLink' | t }}</span>
        </p>
      </div>
    </div>
    <div class="content-column">
      <mat-nav-list>
        <mat-list-item
          role="button"
          [attr.aria-label]="'account.settings.personalInfo.labels.name' | t"
          (click)="!isPersonalInfoReadOnly && editName()"
          [disabled]="isPersonalInfoReadOnly"
        >
          <div matLine>{{ currentUser.fullName }}</div>
          <div matLine class="secondary-text">{{ 'common.name' | t }}</div>
          <sn-icon *ngIf="!isPersonalInfoReadOnly">keyboard_arrow_right</sn-icon>
        </mat-list-item>

        <mat-list-item
          role="button"
          [attr.aria-label]="'account.settings.personalInfo.labels.email' | t"
          (click)="!isPersonalInfoReadOnly && changeEmail()"
          [disabled]="currentUser.isExternal || isPersonalInfoReadOnly"
        >
          <div matLine>{{ currentUser.email }}</div>
          <div matLine class="secondary-text">{{ 'common.email' | t }}</div>
          <sn-icon *ngIf="!currentUser.isExternal && !isPersonalInfoReadOnly">keyboard_arrow_right</sn-icon>
        </mat-list-item>

        <mat-list-item
          role="button"
          [attr.aria-label]="'account.settings.personalInfo.labels.phone' | t"
          (click)="!isPersonalInfoReadOnly && changePhone()"
          [disabled]="isPersonalInfoReadOnly"
        >
          <div matLine>{{ currentUser.mobilePhone | fsPhoneNumber }}</div>
          <div matLine class="secondary-text">{{ 'common.mobilePhone' | t }}</div>
          <sn-icon *ngIf="!isPersonalInfoReadOnly">keyboard_arrow_right</sn-icon>
        </mat-list-item>

        <mat-list-item
          role="button"
          [attr.aria-label]="'account.settings.personalInfo.labels.title' | t"
          (click)="!isPersonalInfoReadOnly && changeTitle()"
          [disabled]="isPersonalInfoReadOnly"
        >
          <div matLine>{{ currentUser.title }}</div>
          <div matLine class="secondary-text">{{ 'common.title' | t }}</div>
          <sn-icon *ngIf="!isPersonalInfoReadOnly">keyboard_arrow_right</sn-icon>
        </mat-list-item>

        <mat-list-item
          role="button"
          [attr.aria-label]="'account.settings.personalInfo.labels.badge' | t"
          (click)="!isPersonalInfoReadOnly && changeBadge()"
          [disabled]="isPersonalInfoReadOnly"
        >
          <div matLine>{{ currentUser.badge }}</div>
          <div matLine class="secondary-text">{{ 'common.badge' | t }}</div>
          <sn-icon *ngIf="!isPersonalInfoReadOnly">keyboard_arrow_right</sn-icon>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </div>
</section>

<section class="account-settings-section">
  <h2 class="account-settings-section-title">
    <sn-icon class="account-settings-section-icon" fontSet="fal" fontIcon="fa-shield"></sn-icon>
    {{ 'account.settings.signInSecurity.title' | t }}
  </h2>
  <div class="account-section-layout">
    <div class="info-column">
      <ng-container *ngIf="!currentUser.isExternal; else externalUser">
        <p class="lead">{{ 'account.settings.signInSecurity.description' | t }}</p>
        <p>
          <b>{{ 'account.settings.signInSecurity.strongPasswordTitle' | t }}</b><br />
          {{ 'account.settings.signInSecurity.strongPasswordDescription' | t }}
        </p>
      </ng-container>
      <ng-template #externalUser>
        <p class="lead">{{ 'account.settings.signInSecurity.externalAuthTitle' | t }}</p>
        <p>
          {{ 'account.settings.signInSecurity.externalAuthDescription' | t }}
        </p>
      </ng-template>
    </div>
    <div class="content-column">
      <mat-nav-list>
        <mat-list-item
          role="button"
          [attr.aria-label]="'account.settings.signInSecurity.labels.password' | t"
          (click)="changePassword()"
          [disabled]="currentUser.isExternal"
        >
          <div matLine>{{ 'common.password' | t }}</div>
          <sn-icon *ngIf="!currentUser.isExternal && !isPersonalInfoReadOnly">keyboard_arrow_right</sn-icon>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </div>
</section>

<section class="account-settings-section">
  <h2 class="account-settings-section-title">
    <sn-icon class="account-settings-section-icon" fontSet="fal" fontIcon="fa-qrcode"></sn-icon>
    {{ 'account.settings.twoFactorAuth.title' | t }}
  </h2>
  <div class="account-section-layout">
    <div class="info-column">{{ 'account.settings.twoFactorAuth.description' | t }}</div>
    <div class="content-column">
      <mat-nav-list>
        <mat-list-item *ngIf="isLoadingMfa && !mfaEnabled">
          <mat-spinner color="accent" diameter="24"></mat-spinner>
        </mat-list-item>
        <mat-list-item [disabled]="true" *ngIf="!isLoadingMfa && mfaEnabled">
          <div class="account-settings-section-title">
            {{ mfaEnabled ? ('common.enabled' | t) : ('account.settings.twoFactorAuth.enable' | t) }}
            <sn-icon style="color: #FFCA28" fontSet="fal" fontIcon="fa-circle-check"></sn-icon>
          </div>
          <sn-icon *ngIf="!mfaEnabled">keyboard_arrow_right</sn-icon>
        </mat-list-item>
        <mat-list-item
          [attr.aria-label]="'account.settings.twoFactorAuth.labels.mfa' | t"
          (click)="manageMfaDevices()"
        >
          <div matLine>{{ 'common.manage' | t }}</div>
          <sn-icon>keyboard_arrow_right</sn-icon>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </div>
</section>
